function toggleHeight(el = HTMLElement) {
  let maxHeight = el.scrollHeight;

  if (el.style.height) {
    el.style.height = null;
  } else {
    el.style.height = /* maxHeight + 'px'; */'100%';
  }
}

window.addEventListener('load', () => {
  const headerEl = document.querySelector('header.header');
  const variant = headerEl.getAttribute('data-mobile-header-menu-submenu-variant');

  // Menu icon
  const menuButton = document.getElementById('nav-icon');
  const getBody = document.body;

  if (menuButton) {
    menuButton.addEventListener('click', (event) => {
      menuButton.classList.toggle('open');
      headerEl.classList.toggle('open-menu');
      getBody.classList.toggle('fix-the-background');
    });
  }

  headerEl.querySelectorAll('[class*=main-menu] .menu-item a').forEach(menuItem => {
    menuItem.addEventListener('click', () => {
      menuButton.classList.toggle('open');
      headerEl.classList.toggle('open-menu');
      getBody.classList.toggle('fix-the-background');
    });
  });

  // Mobile menu
  switch (variant) {
    case 'right-slide':
      headerEl.querySelectorAll('.menu-item--expanded').forEach(menu => {
        const levelElement = menu.querySelector('[class^="menu-level-"]');
        menu.querySelector('.menu-item-expanded-plus').addEventListener('click', (e) => {
          levelElement.classList.add('menu-level-animation');
        });

        levelElement.querySelector('.menu-item-back').addEventListener('click', (e) => {
          levelElement.classList.remove('menu-level-animation');
        });
      });

      break;
    case 'dropdown':
      headerEl.querySelectorAll('.standard-menu>.menu-level-0 .menu-item--expanded').forEach((mainMenuItem) => {
        mainMenuItem.querySelector('.menu-item-expanded-plus').addEventListener('click', (e) => {
          e.target.classList.toggle('active');
          toggleHeight(mainMenuItem.querySelector('ul'));
        });

        mainMenuItem.querySelectorAll('.menu-item-expanded').forEach(subMenuItem => {
          subMenuItem.querySelector('.menu-item-expanded-plus').addEventListener('click', (e) => {
            e.target.classList.toggle('active');
            toggleHeight(subMenuItem.querySelector('ul'));
          });
        });
      });

      headerEl.querySelectorAll('.block-language').forEach((langMenu) => {
        langMenu
          .querySelector('.menu-item-expanded-plus')
          .addEventListener('click', (e) => {
            e.target.classList.toggle('active');
            toggleHeight(langMenu.querySelector('.links'));
          });
      });
      break;
    default:
      break;
  }

  // Tabs
  document.querySelector('main').addEventListener('click', (e) => {
    if (e.target == document.querySelector('.block--primary-local-tasks h2')) {
      let localTasks = document.querySelector('.block--primary-local-tasks');
      if (localTasks.classList.contains('active')) {
        localTasks.classList.remove('active');
      } else {
        localTasks.classList.add('active');
      }
    }
  });
});
